var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBiology(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1333 6.36836C16.7474 7.05813 18.5628 7.11152 20.2147 6.51782M6.01673 20.7158C6.6099 19.0587 6.55653 17.2389 5.86728 15.6194C5.32778 14.33 5.18182 12.9097 5.44776 11.5375C5.7137 10.1652 6.37966 8.9023 7.3618 7.90772C8.36861 6.91132 9.64787 6.23529 11.0383 5.96484",
    stroke: "#005DB8",
    strokeWidth: 1.21429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.90172 16.04C11.2989 15.7673 12.5837 15.0859 13.5932 14.0821M13.5932 14.0821C14.577 13.0886 15.2442 11.8257 15.5102 10.453C15.7762 9.0803 15.6292 7.65955 15.0877 6.37043C14.4125 4.7506 14.3751 2.9353 14.9831 1.28906M13.5932 14.0821L7.42082 7.90978M0.785156 15.487C2.43772 14.8905 4.25596 14.9493 5.86652 15.6514",
    stroke: "#005DB8",
    strokeWidth: 1.21429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiology);
export default __webpack_public_path__ + "static/media/biology.26bc80f442ca276b7d8e60e9ac5d75d6.svg";
export { ForwardRef as ReactComponent };